import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles((theme) => ({
    stepNumber: {
        width: 26,
        height: 26,
    },
}));

const NewTransformationPageStepNavigationNumber: React.FC<{ step: number; isActive: boolean; }> = ({ step, isActive }) => {
    const classes = useStyles();
    return <div
        className={clsx(classes.stepNumber, "font-bold flex justify-center items-center inline-block mr-2 text-white" +
            " rounded-full", isActive ? "bg-purple-700" : "bg-gray-600")}>{step}</div>;
};

export const NewTransformationPageStepNavigation: React.FC<{ step: number }> = ({ step }) => {
    return (
        <div className='w-full flex justify-center'>
            <div className={clsx("flex mr-8 text-gray-500", step === 1 && "text-purple-700")}>
                <NewTransformationPageStepNavigationNumber step={1} isActive={step === 1}/> Transformation Type
            </div>
            <div className={clsx("flex mr-8 text-gray-500", step === 2 && "text-purple-700")}>
                <NewTransformationPageStepNavigationNumber step={2} isActive={step === 2}/> Event Selection
            </div>
            <div className={clsx("flex mr-8 text-gray-500", step === 3 && "text-purple-700")}>
                <NewTransformationPageStepNavigationNumber step={3} isActive={step === 3}/> Transformations
            </div>
        </div>
    );
};